import type {Middleware} from "@reduxjs/toolkit";
import {setAccessToken, setSupportContextHeader} from "../api";
import type {SupportContext} from "../model/user/SupportContext.ts";

interface LoginSuccessAction {
    type: "auth/loginSuccess";
    payload: {
        accessToken: string;
    };
}

interface AuthState {
    auth?: {
        supportContext?: SupportContext | null;
    };
}

const isLoginSuccess = (action: unknown): action is LoginSuccessAction => {
    return (
        typeof action === "object" && action !== null &&
        "type" in action && (action as { type: unknown }).type === "auth/loginSuccess"
    );
};

const apiTokenMiddleware: Middleware = store => next => action => {
    if (isLoginSuccess(action)) {
        setAccessToken(action.payload.accessToken);
    }
    const result = next(action);
    // the request header always follows the support context in the store (#56913)
    setSupportContextHeader((store.getState() as AuthState).auth?.supportContext ?? null);
    return result;
};

export default apiTokenMiddleware;
